<template>
  <!-- Route modal host'u (meta.isModal route'ları, store/modal.js). Estesoft.App
       VueRouterModalComponent'in Vega/BS4 uyarlaması; kabuk BaseModal (body'ye taşınır, Esc,
       odak tuzağı ve iadesi). Başlık işaretlemesi bootstrap-vue dönemindekiyle aynı. -->
  <base-modal ref="modal" :id="currentModalId || null" :size="size" hide-footer @hidden="onHidden">
    <template #header>
      <h5>{{ $t(currentModalTitle) }}</h5>
      <i class="fa-regular fa-xmark close" @click="close()"></i>
    </template>
    <component v-if="dynamicComponent != null" v-bind:is="dynamicComponent" v-bind="componentProps" @closeModal="close" />
  </base-modal>
</template>
<script>
  export default {
    name: 'Modal',
    data() {
      return {
        closed: false
      }
    },
    computed: {
      size() {
        return this.$router.currentRoute.meta.size ?? ''
      },
      currentModalId: function () {
        return this.$store.getters['Modal/currentModalId']
      },
      currentModalTitle: function () {
        return this.$store.getters['Modal/currentModalTitle']
      },
      dynamicComponent: function () {
        return this.$store.getters['Modal/dynamicComponent']
      },
      componentProps: function () {
        return this.$store.getters['Modal/componentProps']
      }
    },
    methods: {
      /* Tek kapatma yolu: X, Esc, arka plan, alt bileşenin closeModal olayı ve $bus
         'CloseModalEvent' hep buradan geçer; route bir kez geri alınır. */
      close() {
        if (this.$refs.modal) this.$refs.modal.hide()
      },
      onHidden() {
        if (this.closed) return
        this.closed = true
        this.$router.go(-1)
        this.$store.dispatch('Modal/setCurrentModalId', '')
        this.$store.dispatch('Modal/setCurrentModalTitle', '')
        this.$store.dispatch('Modal/setDynamicComponent', null)
        this.$store.dispatch('Modal/setComponentProps', null)
      }
    },
    mounted() {
      this.$bus.$on('CloseModalEvent', this.close)
      this.$refs.modal.show()
    },
    beforeUnmount() {
      this.$bus.$off('CloseModalEvent', this.close)
    }
  }
</script>

<style>
  .modal-body {
    padding-bottom: 0px !important;
  }
</style>
